export type WebViewSource = 'android' | 'ios'

export const WEBVIEW_SOURCE_KEY = 'robojastip:webview-source'

let memorySource: WebViewSource | null = null

function parseSource(value: string | null): WebViewSource | null {
  return value === 'android' || value === 'ios' ? value : null
}

/** A UI mode hint, never evidence of identity or authorization. */
export function getWebViewSource(): WebViewSource | null {
  if (typeof window === 'undefined') return null
  try {
    return parseSource(window.sessionStorage.getItem(WEBVIEW_SOURCE_KEY)) ?? memorySource
  } catch {
    return memorySource
  }
}

/** The first valid source owns this tab; missing/invalid params never reset it. */
export function initializeWebViewSession(search: string) {
  const existing = getWebViewSource()
  if (existing || typeof window === 'undefined') return existing

  const sources = new URLSearchParams(search).getAll('source')
  const source = sources.length === 1 ? parseSource(sources[0] ?? null) : null
  if (!source) return null

  memorySource = source
  try {
    window.sessionStorage.setItem(WEBVIEW_SOURCE_KEY, source)
  } catch {
    // Storage restrictions must not break the current page's native mode.
  }
  return source
}

export function isWebViewSession() {
  return getWebViewSource() !== null
}
